import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ContextMenuCommand from './contextmenucommand'
import ContextMenuEditing from './contextmenuediting'

export default class Contextmenu extends Plugin {
  static get requires() {
    return [ContextMenuCommand, ContextMenuEditing];
  }

  static get pluginName() {
    return 'Contextmenu';
  }
}